module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ui_title_line', {
    attrs: {
      "no_left": ""
    }
  }, [_vm._v("\n    СТРАХОВАНИЕ АДВОКАТОВ\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row row-img-text"
  }, [_c('div', {
    staticClass: "col-with-text col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col center-desc"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('ui_text', [_vm._v("\n                Даже огромный опыт и высокая квалификация адвоката не могут, к сожалению, служить гарантией отсутствия ошибок, малейшая из которых может принести значительные убытки. Для минимизации возможных потерь мы предлагаем уникальные программы страхования профессиональной ответственности адвокатов.\n              ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('ui_text', [_vm._v("Страховые риски")])], 1), _vm._v(" "), _c('ul', [_c('li', [_c('ui_text', [_vm._v("ошибочного толкования законодательства")])], 1), _vm._v(" "), _c('li', [_c('ui_text', [_vm._v("ошибок при предоставлении письменных юридических консультаций")])], 1), _vm._v(" "), _c('li', [_c('ui_text', [_vm._v("ошибок в составлении заявлений, жалоб, ходатайств и других документов правового характера")])], 1), _vm._v(" "), _c('li', [_c('ui_text', [_vm._v("неизвещение клиента о последствиях совершаемых юридических действий")])], 1), _vm._v(" "), _c('li', [_c('ui_text', [_vm._v("иные упущения при осуществлении адвокатской деятельности")])], 1)])], 1)])])])]), _vm._v(" "), _c('ui_title_line', [_vm._v("\n    ЗАЯВКА НА ОКАЗАНИЕ УСЛУГИ\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row input-send"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Имя")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adv.name),
      expression: "adv.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "name",
      "placeholder": "Имя"
    },
    domProps: {
      "value": (_vm.adv.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adv, "name", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row input-send"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Телефон")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adv.phone),
      expression: "adv.phone"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('+7(###)-###-##-##'),
      expression: "'+7(###)-###-##-##'"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "+7(###)-###-##-##",
      "type": "text",
      "id": "phone"
    },
    domProps: {
      "value": (_vm.adv.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adv, "phone", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row input-send"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adv.email),
      expression: "adv.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.adv.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adv, "email", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row button-send"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('ui_btn', {
    attrs: {
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.send
    }
  }, [_vm._v("Отправить заявку")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-md-5",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/img/money.svg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-da4d49fa","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Insurance/insurance.vue
// module id = 379
// module chunks = 2